import type { FC } from "react";
import { IconCheckCircle } from "@/assets/icons/geist/IconCheckCircle";
import { OnaWordmark } from "@/assets/icons/OnaWordmark";
import onaGradientBg from "@/assets/ona-gradient.webp";
import { Heading1 } from "@/components/podkit/typography/Headings";
import { Text } from "@/components/podkit/typography/Text";

export const ScmSuccessPage: FC = () => {
    return (
        <div
            className="flex min-h-screen w-full flex-col items-center justify-center bg-cover bg-center bg-no-repeat p-6"
            style={{
                backgroundImage: `url(${onaGradientBg})`,
            }}
        >
            <div className="flex w-full max-w-md flex-col items-center gap-6 rounded-2xl bg-white px-8 py-12 shadow-2xl dark:bg-surface-glass dark:text-white">
                {/* ONA Branding */}
                <OnaWordmark className="mb-2 h-10 w-auto" />

                {/* Success Icon */}
                <div className="flex h-20 w-20 items-center justify-center rounded-full bg-green-100 dark:bg-green-900/30">
                    <IconCheckCircle size="lg" className="h-12 w-12 text-green-600 dark:text-green-400" />
                </div>

                {/* Success Message */}
                <div className="flex flex-col items-center gap-3 text-center">
                    <Heading1 className="text-2xl">Congrats, you&apos;re all set!</Heading1>
                    <Text className="text-base text-content-secondary">
                        Your Git provider is now connected and ready to use.
                    </Text>
                </div>

                {/* Instructions */}
                <div className="flex flex-col items-center gap-1 text-center">
                    <Text muted className="text-sm">
                        Close this tab to continue where you left off.
                    </Text>
                </div>
            </div>
        </div>
    );
};
